export default function ({ store, redirect }) {
    if (store.state.frontend.auth.token) {
        return redirect('/dashboard')
    }
}
